document.addEventListener('DOMContentLoaded', function () {
    setTimeout(function () {
        const sliderProgressList = document.querySelectorAll('.slider-progress');

        sliderProgressList.forEach(function (sliderProgress) {
            const current = parseInt(sliderProgress.getAttribute('data-current'));
            const end = parseInt(sliderProgress.getAttribute('data-end'));
            let percentage = (Math.min(current, end) / end) * 100;

            const sliderProgressC = sliderProgress.querySelector('.slider-current');
            sliderProgressC.style.width = percentage + '%';

            const sliderCurrentProgress = sliderProgress.querySelector('.slider-current__progress');
            sliderCurrentProgress.style.position = 'relative';
            percentage = Math.min(percentage, 89);
            sliderCurrentProgress.style.left = percentage + '%';
        });

        const slliderPr1 = document.querySelector('.slider-progress__wrap1');
        const sliderProgressList1 = document.querySelectorAll('.slider-progress1');

        sliderProgressList1.forEach(function (sliderProgress1) {
            const current1 = parseInt(sliderProgress1.getAttribute('data-current-progress'));
            const end1 = parseInt(sliderProgress1.getAttribute('data-end-progress'));
            let percentage1 = (Math.min(current1, end1) / end1) * 100;
            let percentage3 = Math.min(percentage1, 89);

            const sliderProgressC1 = sliderProgress1.querySelector('.slider-current1');
            sliderProgressC1.style.width = percentage1 + '%';

            const progress3 = slliderPr1.querySelector('.text-wrapper');
            progress3.style.marginLeft = percentage3 - 3 + '%';

            const sliderCurrentProgress1 = sliderProgress1.querySelector('.slider-current__progress1');
            sliderCurrentProgress1.style.position = 'relative';
            percentage1 = Math.min(percentage1, 100);
            sliderCurrentProgress1.style.left = percentage1 + '%';
        });
    }, 1000);
});
